export class Stand {
    Nummer: number;
    Typ: string;

    constructor(nummer: number, typ: string) {
        this.Nummer = nummer;
        this.Typ = typ;
    }
}